:host{display:none}
/*# sourceMappingURL=new-project-dialog-entry.component-2AIV2G2Q.css.map */
